if (!customElements.get('collection-description')) {
  class CollectionDescription extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('[data-collection-description-toggle]');
      const remainingContent = this.querySelector('[data-collection-description-more]');

      if (!button || !remainingContent) return;

      button.addEventListener('click', () => {
        remainingContent.hidden = false;
        button.setAttribute('aria-expanded', 'true');
        button.hidden = true;
      }, { once: true });
    }
  }

  customElements.define('collection-description', CollectionDescription);
}
